"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _glamor = require("glamor");

var _css = require("@quixeltools/quixel-ui-library/dist/utils/css");

var _fonts = require("@quixeltools/quixel-ui-library/dist/utils/fonts");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var fields = (0, _glamor.css)({
  display: "flex",
  flexWrap: "wrap",
  justifyContent: "space-between"
});

var paypalPaymentBox = (0, _glamor.css)({
  backgroundColor: _css.colors.medLightGray,
  position: "relative",
  padding: "1.5em 0"
});

var initBox = (0, _glamor.css)({
  textAlign: "center"
});

var initInfo = (0, _glamor.css)({
  display: "block",
  lineHeight: "1.5"
});

var errorCss = (0, _glamor.css)({
  fontSize: "0.9375rem",
  fontWeight: 400,
  display: "block",
  color: "#f44236",
  marginTop: "0.375rem"
});

var cardHolderNumber = (0, _glamor.css)({
  flexBasis: "100%",
  marginBottom: "24px",
  "& #cardholder-name": {
    height: "48px",
    background: "#0f0f0f!important",
    padding: "0px 0.9rem",
    border: "2px solid #0f0f0f",
    ".braintree-hosted-fields-focused": {
      border: "2px solid rgb(128, 128, 128)"
    },
    ".braintree-hosted-fields-invalid": {
      border: "2px solid #f44236"
    },
    ":hover": {
      border: "2px solid rgb(128, 128, 128)"
    }
  }
}, (0, _css.maxWidth)(_css.breakpoints.mediumSmall)({
  flexBasis: "100%"
}));
var cardNumber = (0, _glamor.css)({
  flexBasis: "48.4375%",
  "& #card-number": {
    height: "48px",
    background: "#0f0f0f!important",
    padding: "0px 0.9rem",
    border: "2px solid #0f0f0f",
    ".braintree-hosted-fields-focused": {
      border: "2px solid rgb(128, 128, 128)"
    },
    ".braintree-hosted-fields-invalid": {
      border: "2px solid #f44236"
    },
    ":hover": {
      border: "2px solid rgb(128, 128, 128)"
    }
  }
}, (0, _css.maxWidth)(_css.breakpoints.mediumSmall)({
  flexBasis: "100%"
}));

var expirationDate = (0, _glamor.css)({
  flexBasis: "21.875%",
  "& #expiration-date": {
    height: "48px",
    background: "#0f0f0f!important",
    padding: "0px 0.9rem",
    border: "2px solid #0f0f0f",
    ".braintree-hosted-fields-focused": {
      border: "2px solid rgb(128, 128, 128)"
    },
    ".braintree-hosted-fields-invalid": {
      border: "2px solid #f44236"
    },
    ":hover": {
      border: "2px solid rgb(128, 128, 128)"
    }
  }
}, (0, _css.maxWidth)(_css.breakpoints.mediumSmall)({
  flexBasis: "46%"
}));

var cvv = (0, _glamor.css)({
  flexBasis: "21.875%",
  "& #cvv": {
    height: "48px",
    background: "#0f0f0f!important",
    padding: "0px 0.9rem",
    border: "2px solid #0f0f0f",
    ".braintree-hosted-fields-focused": {
      border: "2px solid rgb(128, 128, 128)"
    },
    ".braintree-hosted-fields-invalid": {
      border: "2px solid #f44236"
    },
    ":hover": {
      border: "2px solid rgb(128, 128, 128)"
    }
  }
}, (0, _css.maxWidth)(_css.breakpoints.mediumSmall)({
  flexBasis: "46%"
}));

var textinput = (0, _glamor.css)(_fonts.subH4, {
  display: "block",
  color: _css.pallets.gray_text,
  textTransform: "uppercase",
  marginBottom: (0, _css.unitRem)(0.25)
});

// eslint-disable-next-line react/prefer-stateless-function

var CreditCardFormFields = function (_React$Component) {
  (0, _inherits3.default)(CreditCardFormFields, _React$Component);

  function CreditCardFormFields(props) {
    (0, _classCallCheck3.default)(this, CreditCardFormFields);
    return (0, _possibleConstructorReturn3.default)(this, (CreditCardFormFields.__proto__ || (0, _getPrototypeOf2.default)(CreditCardFormFields)).call(this, props));
  }

  (0, _createClass3.default)(CreditCardFormFields, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.props.creditCardPrepare();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {}
  }, {
    key: "render",
    value: function render() {
      var error = this.props.error;


      return _react2.default.createElement(
        "div",
        { id: "checkbox" },
        error ? _react2.default.createElement(
          "div",
          { className: paypalPaymentBox },
          _react2.default.createElement(
            "div",
            { className: initBox },
            _react2.default.createElement(
              "span",
              { className: initInfo },
              _react2.default.createElement(
                "span",
                { className: (0, _glamor.css)(errorCss) },
                error
              )
            )
          )
        ) : _react2.default.createElement(
          "div",
          null,
          _react2.default.createElement(
            "div",
            { className: fields },
            _react2.default.createElement(
              "div",
              { className: cardHolderNumber },
              _react2.default.createElement(
                "label",
                { className: textinput, "for": "#cardholder-name" },
                "CARD HOLDER NAME"
              ),
              _react2.default.createElement("div", { id: "cardholder-name", "class": "hosted-field" })
            )
          ),
          _react2.default.createElement(
            "div",
            { className: fields },
            _react2.default.createElement(
              "div",
              { className: cardNumber },
              _react2.default.createElement(
                "label",
                { className: textinput, "for": "card-number" },
                "CREDIT CARD NUMBER"
              ),
              _react2.default.createElement("div", { id: "card-number", "class": "hosted-field" })
            ),
            _react2.default.createElement(
              "div",
              { className: expirationDate },
              _react2.default.createElement(
                "label",
                { className: textinput, "for": "expiration-date" },
                "EXPIRY DATE"
              ),
              _react2.default.createElement("div", { id: "expiration-date", "class": "hosted-field" })
            ),
            _react2.default.createElement(
              "div",
              { className: cvv },
              _react2.default.createElement(
                "label",
                { className: textinput, "for": "cvv" },
                "CVC"
              ),
              _react2.default.createElement("div", { id: "cvv", "class": "hosted-field" })
            )
          )
        )
      );
    }
  }]);
  return CreditCardFormFields;
}(_react2.default.Component);

exports.default = CreditCardFormFields;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/CreditCardFormFields/CreditCardFormFields.jsx
// module id = 2350
// module chunks = 0